"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5494],{

/***/ 25494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FavoriteAction": function() { return /* binding */ FavoriteAction; }
/* harmony export */ });
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4730);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72145);
/* harmony import */ var _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85014);
/* harmony import */ var _recoil_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8612);
/* harmony import */ var _recoil_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89093);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5434);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2804);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53913);
/* harmony import */ var _actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_actions_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(53990);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);


var _excluded = ["referance", "referanceId", "is_favorite", "fetchFavCourseData", "fetchFavUniData"];













var FavoriteAction = function FavoriteAction(_ref) {
  var referance = _ref.referance,
      referanceId = _ref.referanceId,
      is_favorite = _ref.is_favorite,
      _ref$fetchFavCourseDa = _ref.fetchFavCourseData,
      fetchFavCourseData = _ref$fetchFavCourseDa === void 0 ? false : _ref$fetchFavCourseDa,
      _ref$fetchFavUniData = _ref.fetchFavUniData,
      fetchFavUniData = _ref$fetchFavUniData === void 0 ? false : _ref$fetchFavUniData,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref, _excluded);

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var profileInfo = (0,recoil__WEBPACK_IMPORTED_MODULE_7__/* .useRecoilValue */ .sJ)(_recoil_state__WEBPACK_IMPORTED_MODULE_5__/* .authAtom */ .L4);
  var systemActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useSystemActions */ .x3)();
  var authActions = (0,_recoil_actions__WEBPACK_IMPORTED_MODULE_4__/* .useAuthActions */ .X$)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    //remove redirect url
    systemActions.removeReturnUrl();
  }, []); //Handle University Favourite

  var handleUniFavourite = /*#__PURE__*/function () {
    var _ref2 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(universityId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);

              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/student/favourite-university", {
                universityId: universityId
              }).then( /*#__PURE__*/function () {
                var _ref3 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context.next = 7;
                            break;
                          }

                          if (fetchFavUniData) fetchFavUniData();
                          _context.next = 4;
                          return authActions.getProfile();

                        case 4:
                          setIsLoading(false);
                          _context.next = 9;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 4:
              _context2.next = 15;
              break;

            case 6:
              if (!(profileInfo && profileInfo.userTypeSlug !== "student")) {
                _context2.next = 11;
                break;
              }

              setIsLoading(false);
              return _context2.abrupt("return");

            case 11:
              setIsLoading(false);
              systemActions.setReturnUrl(router.asPath);
              _context2.next = 15;
              return router.push({
                pathname: "/signin"
              });

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUniFavourite(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); //course favorite


  var handleCourseFavourite = /*#__PURE__*/function () {
    var _ref4 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(courseId) {
      return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setIsLoading(true);

              if (!(profileInfo && profileInfo.userTypeSlug === "student")) {
                _context4.next = 6;
                break;
              }

              _context4.next = 4;
              return _unisearch_helpers_api__WEBPACK_IMPORTED_MODULE_3__/* ["default"].post */ .Z.post("/student/favorite-course", {
                courseId: courseId
              }).then( /*#__PURE__*/function () {
                var _ref5 = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(resp) {
                  return _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!resp.error && resp.data)) {
                            _context3.next = 7;
                            break;
                          }

                          if (fetchFavCourseData) fetchFavCourseData();
                          _context3.next = 4;
                          return authActions.getProfile();

                        case 4:
                          setIsLoading(false);
                          _context3.next = 9;
                          break;

                        case 7:
                          (0,_unisearch_helpers__WEBPACK_IMPORTED_MODULE_2__/* .swalError */ .Kj)(resp.error);
                          setIsLoading(false);

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x4) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 4:
              _context4.next = 15;
              break;

            case 6:
              if (!(profileInfo && profileInfo.userTypeSlug !== "student")) {
                _context4.next = 11;
                break;
              }

              setIsLoading(false);
              return _context4.abrupt("return");

            case 11:
              setIsLoading(false);
              systemActions.setReturnUrl(router.asPath);
              _context4.next = 15;
              return router.push({
                pathname: "/signin"
              });

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleCourseFavourite(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var renderComponent = function renderComponent() {
    //for active
    if (is_favorite == false) {
      if (referance && referance == "university" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdFavoriteBorder */ .iqB, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart)),
            onClick: function onClick() {
              return handleUniFavourite(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), !profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Add to ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " favourite"]
          })]
        });
      }

      if (referance && referance == "course" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdFavoriteBorder */ .iqB, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart)),
            onClick: function onClick() {
              return handleCourseFavourite(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), !profileInfo ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Please Login ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " to perform this action"]
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Add to ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " favourite"]
          })]
        });
      }
    } //for inactive


    if (is_favorite == true) {
      if (referance && referance == "university" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdFavorite */ .Yqy, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().selected)),
            onClick: function onClick() {
              return handleUniFavourite(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Remove from ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " favourite"]
          })]
        });
      }

      if (referance && referance == "course" && referanceId != "") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
          className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().favourite_wrapper), "  relative"),
          children: [!isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_12__/* .MdFavorite */ .Yqy, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_heart), " ").concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().selected)),
            onClick: function onClick() {
              return handleCourseFavourite(referanceId);
            }
          }), referanceId && isLoading && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_13__/* .ImSpinner8 */ .IDg, {
            className: "".concat((_actions_module_scss__WEBPACK_IMPORTED_MODULE_11___default().icon_spin))
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            className: "uni-tooltip",
            children: ["Remove from ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("br", {}), " favourite"]
          })]
        });
      }
    }
  };

  if (true) {
    return renderComponent();
  }

  return false;
};
/* harmony default export */ __webpack_exports__["default"] = (FavoriteAction);

/***/ })

}]);